// Backing API host. Set via the REACT_APP_API_BASE_URL build-time env var
// (see .env.production / .env.development, and the Dockerfile / Dockerfile.dev
// which set it explicitly for containerized builds). Falls back to production
// if the build somehow ran without it set.
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.sunsure-agent.com";
